var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgProcessingSpinner = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "#fff",
  "aria-labelledby": "title",
  viewBox: "0 0 32 32"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M16 0a16 16 0 0 0 0 32 16 16 0 0 0 0-32m0 4a12 12 0 0 1 0 24 12 12 0 0 1 0-24",
  opacity: 0.25
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M16 0a16 16 0 0 1 16 16h-4A12 12 0 0 0 16 4z"
}, /*#__PURE__*/React.createElement("animateTransform", {
  attributeName: "transform",
  dur: "0.8s",
  from: "0 16 16",
  repeatCount: "indefinite",
  to: "360 16 16",
  type: "rotate"
}))));
export default SvgProcessingSpinner;